import { jsx as _jsx } from "react/jsx-runtime";
import { Dropdown } from '..';
import { DotsVerticalIcon } from '../../icons';
export function OptionsDropdown({ options, icon: Icon = DotsVerticalIcon }) {
    return (_jsx(Dropdown, { options: options, children: _jsx("button", { className: "p-2 border border-transparent hover:border-gray-100 hover:bg-white rounded-xl transition-colors", children: _jsx(Icon, { className: "size-4 text-gray-700" }) }) }));
}
